import React from "react";
import { Input, Space, Divider } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { Line } from "@ant-design/charts";
import { DATA } from "../myanfinviz";
import { ModeSelect } from "./explore/ModeSelect";
import { EXPLORE_MODES } from "./explore/constants";
import { Individual } from "./explore/Individual";
import { Visual } from "./explore/Visual";
import TableView from "./TableView";
import Compare from "./explore/Compare";

export default class ExploreDashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mode: EXPLORE_MODES.VISUAL.value,
    };
  }

  setMode = (mode) => {
    this.setState({ mode });
  };

  onSelectMode = (mode) => {
    this.setMode(mode);
  };

  renderMode = (mode) => {
    const { setSelectedMenuKey } = this.props;
    switch (mode) {
      case EXPLORE_MODES.VISUAL.value:
        return <Visual />;
      case EXPLORE_MODES.TABLE.value:
        return <TableView />;
      case EXPLORE_MODES.SEARCH.value:
        return <Individual />;
      case EXPLORE_MODES.COMPARE.value:
        return <Compare />;
      default:
        return null;
    }
  };

  render() {
    console.log("ExploreDashboard", this.state);
    console.log("ExploreDashboard mode", this.props.match.params.mode);
    const { mode } = this.state;
    return (
      <div>
        <Space>
          <h2 className="mb-0">Explore Dashboard</h2>
        </Space>

        <Divider />
        {this.renderMode(this.props.match.params.mode)}
      </div>
    );
  }
}
